import { tv } from "@opensea/ui-kit"

export const slideClasses = tv({
  base: "size-full shrink-0 basis-4/5 sm:basis-[calc(50%_-_8px)]",
  variants: {
    variant: {
      team: "lg:basis-[calc(20%_-_14px)]",
      item: "lg:basis-[calc(20%_-_14px)]",
      default: "3xl:basis-[calc(25%_-_12px)] lg:basis-[calc(33.33%_-_11px)]",
    },
  },
  defaultVariants: {
    variant: "default",
  },
})
